import { A } from "@solidjs/router"
import { createMemo, For, type JSXElement, Show } from "solid-js"
import { Box } from "../components/box"
import { Pagination } from "../components/pagination"
import { Info } from "./info"
import { itemClass, linkClass, listClass } from "./list.css"

type Props<T> = {
  list: T[]
  headerOptions?: JSXElement
  content: (item: T) => JSXElement
  href: (item: T) => string
  pagination?: {
    size?: number
    page: number
    path: (page: number) => string
  }
}
export function List<T>(props: Props<T>) {
  const size = createMemo(() => props.pagination?.size ?? 50)
  const list = createMemo(() => {
    const pagination = props.pagination
    if (!pagination) {
      return props.list
    }

    return props.list.slice(
      (pagination.page - 1) * size(),
      pagination.page * size(),
    )
  })
  const totalPages = createMemo(() => {
    const pagination = props.pagination
    if (!pagination) return 1

    return Math.ceil(props.list.length / size())
  })

  return (
    <Box gap="12" fill>
      <Show when={props.headerOptions}>{props.headerOptions}</Show>
      <Show when={list().length} fallback={<Info>No results</Info>}>
        <ul class={listClass}>
          <For each={list()}>
            {element => (
              <li class={itemClass}>
                <A href={props.href(element)} class={linkClass}>
                  {props.content(element)}
                </A>
              </li>
            )}
          </For>
        </ul>
        <Show when={props.pagination}>
          {pagination => (
            <Show when={list().length < props.list.length}>
              <Pagination
                page={pagination().page}
                totalPages={totalPages()}
                paginationPath={pagination().path}
              />
            </Show>
          )}
        </Show>
      </Show>
    </Box>
  )
}
